import { useState, useCallback, useEffect } from 'react'
import { Error } from '@myap/ui-library/cjs/components'
import { AP_AGREEMENT_FIELDS as FIELDS } from '../../../constants/SetupConstants'
import { Input } from '../../common'
import APAgreementContent from './apagreementcontent'
import stylesheet from '../../../assets/style/scss/terms-and-conditions.scss'
import ScrollableContainer from '../../common/ScrollableContainer'

const ApAgreementForm = ({ error, initialValues, currentValues, onViewedChange, className }) => {
  const [hasViewedApAgreement, setHasViewedApAgreement] = useState(false)
  const [displayViewAllError, setDisplayViewAllError] = useState(false)

  const handleScrollToBottom = useCallback(() => {
    setHasViewedApAgreement(true)
    setDisplayViewAllError(false)
    if (onViewedChange) onViewedChange(true)
  }, [onViewedChange])

  useEffect(() => {
    if (initialValues[FIELDS.AP_AGREEMENT_IND.name]) {
      setHasViewedApAgreement(true)
    }
    const onClick = () => {
      if (!hasViewedApAgreement) {
        setDisplayViewAllError(true)
      }
    }
    document.addEventListener('click', onClick)
    return () => {
      document.removeEventListener('click', onClick)
    }
  }, [hasViewedApAgreement, initialValues[FIELDS.AP_AGREEMENT_IND.name]])

  return (
    <div className={className} style={{ marginTop: 20 }}>
      {error ? <Error message={error} /> : null}
      <h2 className="h1">AP Agreement</h2>
      <ScrollableContainer
        onScrollToBottom={handleScrollToBottom}
        className={`${stylesheet['tac-container']}`}
      >
        <APAgreementContent />
      </ScrollableContainer>
      <div className={`checkbox ${stylesheet['tac-check']}`}>
        <Input
          type="checkbox"
          name={FIELDS.AP_AGREEMENT_IND.name}
          label="I have read and agree to the AP Agreement."
          isRequired={FIELDS.AP_AGREEMENT_IND.required}
          disabled={!hasViewedApAgreement && !currentValues[FIELDS.AP_AGREEMENT_IND.name]}
        />
        {!currentValues[FIELDS.AP_AGREEMENT_IND.name] && displayViewAllError && (
          <span className="alert-danger cb-alert-heading">
            You must view and read all of the AP Agreement first to accept.
          </span>
        )}
      </div>
    </div>
  )
}

export default ApAgreementForm
